import React, { useEffect } from 'react';
import UserAvatar from '../../components/UserAvatar';
import { Form, Card } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion'
import { useState } from 'react';
import LanguageContext from '../../helper/LanguageContext';
import { DE } from '../../Languages/DE';
import { EN } from '../../Languages/EN';
import { callAPI } from "../../helper/apiUtils";
import _ from "lodash";
import { BASE_URL } from "../../helper/constants";
import { $crud } from "../../helper/CrudFactory";
import { $user } from '../../helper/UserFactory';
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'react-redux';
import { SET_USER, UPDATE_GROUP_MESSAGE, UPDATE_PROJECT_ACTION_FIRE } from '../../store';
import ModernToggleSwitch from '../../components/ModernToggleSwitch';
import InfoTip from '../../components/InfoTip';
import ProjectMembers from './ProjectMembers';
import EditProject from './EditProject';
import "../../styles/pages.css";
import "./ProjectSettings.css";

function ProjectSettings(props) {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const { isGerm, strings } = React.useContext(LanguageContext);
    const [display, setDisplay] = useState("0")
    const [company, setCompany] = useState({})
    const [users, setUsers] = useState([])
    const [allUsers, setAllUsers] = useState([])
    const [admins, setAdmins] = useState([])
    const [allAdmins, setAllAdmins] = useState([])
    const [search, setSearch] = useState('')
    const [dashboard, setDashboard] = useState({})
    const [setting, setSetting] = useState({})
    const history = useHistory();
    const [totalAdmins, setToalAdmins] = useState(0)
    const [viewLoader, setViewLoader] = useState(false)
    const [departmentPersons, setdepPersons] = useState([])
    const [isDone, setIsDone] = useState(props.isDone)

    const handleClass = (index) => {
        if (display === index) {
            setDisplay(null)
        } else {
            setDisplay(index)

        }
    }

    useEffect(() => {
        setAdmins(props.members)
        setAllAdmins(props.members)
        if (props.members?.length > 0) {
            let tadmins = []
            props.members.map((e, z) => {
                e.names.map((j, k) => {
                    if (j.buldingAdmin) {
                        tadmins.push(j.id)
                    }
                })
            })
            setToalAdmins(tadmins.length)
        }
        console.log(props.members)
    }, [props.members])

    const getDashboard = async () => {
        const id = props.match.params.id
        const { data } = await callAPI(`/company/${id}/dashboard`, {}, 'GET')
        await setDashboard(data.dashboard)
    }
    const getSetting = async () => {
        const id = props.match.params.id
        const { data } = await callAPI(`/company/${id}/setting`, {}, 'GET')
        await setSetting(data)
    }

    const getCompanyDetails = async () => {
        const id = props.match.params.id
        const { data } = await callAPI(`/company/${id}/profile`, {}, 'GET')
        if (data.status) {
            await setCompany(data.profile)
            getCompanyAdmins(data.profile);
            getEmployeesDept(data.profile)
        }
    }
    const getCompanyAdmins = async (profile) => {
        const id = props.match.params.id
        const { data } = (props.match.params.deptId && profile?.role != "ROLE_COMPANY_SUPER_ADMIN") ? await callAPI(`/company/${id}/admin?position=departmentadmin&deptLocation=${props.match.params.deptId}`, {}, 'GET') : await callAPI(`/company/${id}/admin`)
        await CreateAdminList(data.coworker, profile)
    }


    const getEmployeesDept = async (profile) => {
        const id = props.match.params.id;
        const { data } = await callAPI(`/company/${id}/request?deptLocation=${props.match.params.deptId}`, {}, "GET");
        if (data.status && data.members.length > 0) {
            getEmployees(data.members, profile)
        }
        else {
            getEmployees(null, profile);
        }
    };

    const getEmployees = async (depmem, profile) => {
        const id = props.match.params.id
        const { data } = (props.match.params.deptId && profile?.role != "ROLE_COMPANY_SUPER_ADMIN") ? await callAPI(`/company/${id}/coworker?position=departmentadmin&deptLocation=${props.match.params.deptId}`, {}, 'GET') : await callAPI(`/company/${id}/coworker`, {}, 'GET');
        if (profile?.role != "ROLE_COMPANY_SUPER_ADMIN") {
            let usersToFind = []
            if (depmem && depmem.length > 0 && (data.coworkers && data.coworkers.length > 0)) {
                for (let obj of depmem) {
                    for (let objx of data.coworkers) {
                        if (obj.id == objx.id) {
                            usersToFind.push(objx)
                        }
                    }
                }
                await CreateList(usersToFind)
            }
            else {
                setUsers([])
                setAllUsers([])
            }
        }
        else {
            await CreateList(data.coworkers)
        }
    }
    const CreateList = async (users) => {
        const arr = await _.uniqBy(users.map((user) => {
            let name = { name: user.lastName.trim()[0].toUpperCase() }
            return name;
        }), 'name');
        const updatedArr = _.sortBy(arr, ["name"]);
        const usersList = updatedArr.map((a) => {
            let names = users.filter(u => u.lastName.trim()[0].toUpperCase() === a.name)
            names = names.map((e, i) => {
                return { ...e }
            })
            a.names = names;
            return a;
        })
        setUsers([...usersList])
        setAllUsers([...usersList])
    }

    const CreateAdminList = async (admins, profile) => {
        if (admins && admins.length && admins.length > 0) {
            const arr = _.uniqBy(admins.map((user) => {
                let name = { name: user.lastName.trim()[0].toUpperCase() }
                return name;
            }), 'name');
            const updatedArr = _.sortBy(arr, ["name"]);
            let tt = []
            const usersList = updatedArr.map((a) => {
                let names = admins.filter(u => u.lastName.trim()[0].toUpperCase() === a.name)
                names = names.map((e, i) => {
                    return {
                        ...e, buldingAdmin
                            : (e.position == 'EMPLOYEE' || e.position == "COMPANY_DEPARTMENT_ADMIN") ? false : true
                    }
                })
                let tAdmins = names.filter(e => e.buldingAdmin
                )
                tt = [...tt, ...tAdmins]
                a.names = names;
                return a;
            })
            setToalAdmins(tt.length)
            setAdmins([...usersList])
            setAllAdmins([...usersList])
            _makeDep(admins, profile)
        }
    }
    const _makeDep = (admins, profile) => {
        if (admins && admins.length && admins.length > 0) {
            const arr = _.uniqBy(admins.map((user) => {
                let name = { name: user.lastName.trim()[0].toUpperCase() }
                return name;
            }), 'name');
            const updatedArr = _.sortBy(arr, ["name"]);
            let tt = []
            const usersList = updatedArr.map((a) => {
                let names = admins.filter(u => u.lastName.trim()[0].toUpperCase() === a.name)
                names = names.map((e, i) => {
                    return {
                        ...e, buldingAdmin
                            : (e.position == 'EMPLOYEE') ? false : true
                    }
                })
                let tAdmins = names.filter(e => e.buldingAdmin
                )
                tt = [...tt, ...tAdmins]
                a.names = names;
                return a;
            })
            setdepPersons(usersList)
        }
    }
    const filterUsers = async (text) => {
        setSearch(text)
        if (text !== '') {
            let userListFilter = users;
            let positionIndex = await users.findIndex(item => item.name?.toLowerCase() == text?.toLowerCase());
            if (positionIndex !== -1) {
                console.log(positionIndex);
                userListFilter = [userListFilter[positionIndex]]
                console.log(userListFilter)
            } else {
                let userListFilter = await users.map(item => {
                    console.log(positionIndex);
                    let filterName = item.names.filter(i => i.fullName?.toLowerCase().includes(text?.toLowerCase()));
                    return { ...item, names: filterName };
                });
                userListFilter = userListFilter.filter(position => position.names.length > 0)
                console.log(userListFilter)
                setUsers(userListFilter)
            }
        } else {
            setUsers(allUsers)
        }
    }
    const filterAdmins = async (searchValue) => {
        setSearch(searchValue)
        searchValue = searchValue.trim();
        if (searchValue) {
            let userListFilter = await allAdmins.map(item => {
                let filterName = item.names.filter(itm => {
                    const fullName = `${itm.firstName.trim()} ${itm.lastName.trim()}`?.toLowerCase();
                    if (itm.firstName?.toLowerCase().trim().startsWith(searchValue?.toLowerCase()) || itm.lastName.trim()?.toLowerCase().startsWith(searchValue?.toLowerCase()) || fullName?.toLowerCase().startsWith(searchValue?.toLowerCase())) {
                        return true
                    }
                    // const fullName = `${i.firstName}${i.lastName}`?.toLowerCase();
                    // const reversedFullName = `${i.firstName}${i.lastName}`?.toLowerCase();
                    // const trimmedSearchValue = searchValue.replace(/\s+/g, '')?.toLowerCase();
                    // return fullName.includes(trimmedSearchValue) || reversedFullName.includes(trimmedSearchValue);
                });
                return { ...item, names: filterName };
            });
            userListFilter = userListFilter.filter(position => position.names.length > 0)
            setAdmins(userListFilter)
        }
        else {
            setAdmins(allAdmins)
        }
    }

    const filterAdminsDeps = async (searchValue) => {
        setSearch(searchValue)
        if (searchValue !== '') {
            let userListFilter = admins;
            let positionIndex = await admins.findIndex(item => {
                const fullName = `${item.firstName}${item.lastName}`?.toLowerCase();
                const reversedFullName = `${item.firstName}${item.lastName}`?.toLowerCase();
                const trimmedSearchValue = searchValue.replace(/\s+/g, '')?.toLowerCase();
                return fullName.includes(trimmedSearchValue) || reversedFullName.includes(trimmedSearchValue);
            });
            if (positionIndex !== -1) {
                userListFilter = [userListFilter[positionIndex]]
            } else {
                let userListFilter = await admins.map(item => {
                    let filterName = item.names.filter(i => {
                        const fullName = `${i.firstName}${i.lastName}`?.toLowerCase();
                        const reversedFullName = `${i.firstName}${i.lastName}`?.toLowerCase();
                        const trimmedSearchValue = searchValue.replace(/\s+/g, '')?.toLowerCase();
                        return fullName.includes(trimmedSearchValue) || reversedFullName.includes(trimmedSearchValue);
                    });
                    return { ...item, names: filterName };
                });
                userListFilter = userListFilter.filter(position => position.names.length > 0)
                setdepPersons(userListFilter)
            }
        } else {
            setdepPersons(allAdmins)
        }
    }

    const removeUser = async (id, name, i, mainIndex) => {
        await $crud.confirm({
            title: strings.remove_member,
            textContent: strings.do_you_really_want_to_remove.replace('username', name),
            options: {
                ok: strings.confirm,
                cancel: strings.cancel
            }
        });
        setViewLoader(true)
        const companyId = props.match.params.id;
        const { data } = await callAPI(`/company/${id}/remove/${companyId}`, {
            id: id, companyId: companyId
        }, 'GET');
        if (data.status) {
            $crud.notify({
                type: 'success',
                message: data.message
            })
            let tmp = [...users]
            tmp[mainIndex].names.splice(i, 1)
            setUsers([...tmp])
            // setAllUsers([...tmp])
            // await getCompanyAdmins();
            // await getEmployeesDept(company);
            // getCompanyDetails()
        }
        setViewLoader(false)
    }

    const assignAdminRights = async (id, index, buldingAdmin, mainIndex) => {
        setViewLoader(true)
        if (!buldingAdmin) {
            const { data } = await callAPI(`/building/${props.project_id}/admin/${id}`, null, 'GET');
            if (data.status) {
                $crud.notify({
                    type: 'success',
                    message: data.message
                })
                // Create deep copies to avoid mutation
                let tmpAdmins = admins.map(group => ({
                    ...group,
                    names: group.names.map(user => ({ ...user }))
                }))
                let tmpAllAdmins = allAdmins.map(group => ({
                    ...group,
                    names: group.names.map(user => ({ ...user }))
                }))
                
                // Update the specific user's admin status
                tmpAdmins[mainIndex].names[index].buldingAdmin = true
                tmpAllAdmins[mainIndex].names[index].buldingAdmin = true
                
                setAdmins(tmpAdmins)
                setAllAdmins(tmpAllAdmins)
                
                // Recalculate total admins
                let newTotalAdmins = 0
                tmpAllAdmins.forEach(group => {
                    group.names.forEach(user => {
                        if (user.buldingAdmin) {
                            newTotalAdmins++
                        }
                    })
                })
                setToalAdmins(newTotalAdmins)
            }
            else {
                $crud.notify({
                    type: 'error',
                    message: data.message
                })
            }
        }
        else {
            const { data } = await callAPI(`/building/${props.project_id}/admin/${id}`, null, 'DELETE');
            if (data.status) {
                $crud.notify({
                    type: 'success',
                    message: data.message
                })
                // Create deep copies to avoid mutation
                let tmpAdmins = admins.map(group => ({
                    ...group,
                    names: group.names.map(user => ({ ...user }))
                }))
                let tmpAllAdmins = allAdmins.map(group => ({
                    ...group,
                    names: group.names.map(user => ({ ...user }))
                }))
                
                // Update the specific user's admin status
                tmpAdmins[mainIndex].names[index].buldingAdmin = false
                tmpAllAdmins[mainIndex].names[index].buldingAdmin = false
                
                setAdmins(tmpAdmins)
                setAllAdmins(tmpAllAdmins)
                
                // Recalculate total admins
                let newTotalAdmins = 0
                tmpAllAdmins.forEach(group => {
                    group.names.forEach(user => {
                        if (user.buldingAdmin) {
                            newTotalAdmins++
                        }
                    })
                })
                setToalAdmins(newTotalAdmins)
            }
            else {
                $crud.notify({
                    type: 'error',
                    message: data.message
                })
            }
        }
        setViewLoader(false)
    }

    const _removeMyself = async () => {
        setViewLoader(true)
        const { data } = await callAPI(`/building/${props.project_id}/admin/${user.id}`, null, 'DELETE');
        if (data.status) {
            $crud.notify({
                type: 'success',
                message: data.message
            })
            setViewLoader(false)
            props.handleEditClose()
            // Reload the page to reflect the updated admin status
            window.location.reload()
        }
        else {
            $crud.notify({
                type: 'error',
                message: data.message
            })
            setViewLoader(false)
            props.handleEditClose()
        }
    }


    const toggleDone = async (translation) => {
        let msg = "";
        if (translation) {
            msg = !isGerm
                ? EN.mark_is_done
                : DE.mark_is_done
        }
        else {
            msg = !isGerm
                ? EN.mark_not_done
                : DE.mark_not_done
        }
        await $crud.confirm({
            title: "",
            textContent: msg,
            options: {
                ok: strings.confirm,
                cancel: strings.cancel,
            },
        });
        const { data } = await callAPI(
            `/building/changeBuildingStatus`,
            {
                id: props.project_id,
                isDone: !isDone,
            },
            "POST"
        );
        if (data.status) {
            $crud.notify({
                type: "success",
                message: data.message,
            });
            const nowDone = !isDone;
            props.changeIsDone(nowDone)
            setIsDone(nowDone)
            dispatch({
                type: UPDATE_PROJECT_ACTION_FIRE,
                updateProjectActionFire: true,
            })
            if (nowDone && props.onRoomCompleted) {
                props.onRoomCompleted();
            }
        }
    };


    return (
        <div
            className="setting_profile project-settings"
        >
            {viewLoader && (
                <div className="website_loader">
                    <div className="loader" />
                </div>
            )}
            <div className="company_header project-settings__header">
                <div className="heading_icon m-0">
                    <h3 
                        className={props.isInternal ? "main_heading main_heading-internal project-settings__title" : "main_heading project-settings__title"}
                    >
                        <span 
                            className={`material-symbols-outlined material-arrow-left ${props.isInternal ? 'internal-arrow' : ''}`}
                            onClick={(e) => props.handleEditClose()}
                        >
                          keyboard_arrow_left
                        </span>
                        {props.name}
                    </h3>
                </div>
            </div>
            <div className="setting_accrd project-settings__body">
                <Accordion defaultActiveKey="0">
                    {(!props.viewByOwner && props.isJoin && !isDone) && (
                    <Card className="settings-accordion-card">
                        <div className="settings-accordion-panel">
                        <Accordion.Toggle as="div" className="card-header settings-accordion-panel-header kj-pointer" variant="link" eventKey="edit"
                            onClick={() => handleClass('edit')}
                        >
                            <span className="settings-row-left project-settings__label">
                                {strings.edit_company_details || strings.edit}
                            </span>
                            <div className="settings-row-right">
                            <span
                                className={`material-symbols-outlined project-settings__chevron${display === 'edit' ? ' project-settings__chevron--open' : ''}`}
                            >
                                keyboard_arrow_down
                            </span>
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="edit">
                            <div className="settings-accordion-panel-collapse">
                            <Card.Body className="settings-room-edit-body">
                                <EditProject
                                    embedded
                                    project_id={props.project_id}
                                    handleEditClose={() => {}}
                                    isInternal={props.isInternal}
                                    isAdmin={props.isAdmin}
                                    name={props.name}
                                    projectDetails={props.projectDetails}
                                />
                            </Card.Body>
                            </div>
                        </Accordion.Collapse>
                        </div>
                    </Card>
                    )}
                    <Card className="settings-accordion-card">
                        <div className="settings-accordion-panel">
                        <Accordion.Toggle as="div" className="card-header settings-accordion-panel-header kj-pointer" variant="link" eventKey="members"
                            onClick={() => {
                                handleClass('members');
                                if (typeof props.onExpandMembers === "function") props.onExpandMembers();
                            }}
                        >
                            <span className="settings-row-left project-settings__label">
                                {strings.remove_members || strings.room_action_members || strings.room_members}
                            </span>
                            <div className="settings-row-right">
                            <span
                                className={`material-symbols-outlined project-settings__chevron${display === 'members' ? ' project-settings__chevron--open' : ''}`}
                            >
                                keyboard_arrow_down
                            </span>
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="members">
                            <div className="settings-accordion-panel-collapse">
                            <Card.Body className="settings-room-members-body">
                                <div className="admin_right">
                                    <div className="search_div">
                                        <div className="search">
                                            <Form.Group controlId="settingsMembersSearch">
                                                <Form.Control
                                                    autoComplete="off"
                                                    value={props.searchUser || ""}
                                                    type="search"
                                                    placeholder={strings.search}
                                                    onChange={(e) => props.filterAdmins?.(e.target.value)}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <ProjectMembers
                                        embedded
                                        filterAdmins={props.filterAdmins}
                                        users={props.users || props.members}
                                        searchUser={props.searchUser}
                                        _deleteMemberFromProject={props._deleteMemberFromProject}
                                        project_id={props.project_id}
                                        projectDetails={props.projectDetails}
                                        currentMember={props.currentMember}
                                        handleEditClose={() => {}}
                                        isInternal={props.isInternal}
                                        members={props.users || props.members}
                                        name={props.name}
                                        isJoin={props.isJoin}
                                        viewByOwner={props.viewByOwner}
                                        leaveProject={props.leaveProject}
                                        isDone={props.isDone}
                                        isAdmin={props.isAdmin}
                                    />
                                </div>
                            </Card.Body>
                            </div>
                        </Accordion.Collapse>
                        </div>
                    </Card>
                    {props.isAdmin && !isDone ?
                        <Card className="settings-accordion-card">
                            <div className="settings-accordion-panel">
                            <Accordion.Toggle as="div" className="card-header settings-accordion-panel-header kj-pointer" variant="link" eventKey="1"
                                onClick={e => handleClass('1')}>
                                <span className="settings-row-left project-settings__label">
                                    {strings.add_remove_Poss}
                                </span>
                                <div className="settings-row-right">
                                <span 
                                    className={`material-symbols-outlined project-settings__chevron${display === '1' ? ' project-settings__chevron--open' : ''}`}
                                >
                                    keyboard_arrow_down
                                </span>
                                </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="1">
                                <div className="settings-accordion-panel-collapse">
                                <Card.Body>
                                    <div className="admin_right">
                                        <div className="search_div">
                                            <div className="search">
                                                <Form.Group controlId="exampleForm.ControlInput1">
                                                    <Form.Control autocomplete="off" value={search}
                                                        type="search"
                                                        placeholder={strings.search}
                                                        onChange={e => filterAdmins(e.target.value)} />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className="admin-content">
                                        {
                                            admins &&
                                            _.sortBy(admins, [us => us?.lastName?.toLowerCase()], ['lastName'])
                                            .flatMap((admin, adminIndex) =>
                                                admin.names
                                                .filter(u => !u.requestNotYetAccepted)
                                                .map((u, i) => (
                                                        <div className="admin-contact" key={`${admin.name}-${i}`} onClick={async () => {
                                                            await $crud.confirm({
                                                                title: '',
                                                                textContent: !u.buldingAdmin ? (strings.add_member_admin_right) : (strings.remove_member_admin_right),
                                                                options: {
                                                                    ok: strings.confirm,
                                                                    cancel: strings.cancel
                                                                }
                                                            });
                                                            assignAdminRights(u.id, i, u.buldingAdmin, adminIndex)
                                                        }}>
                                                            <div className="row m-0 ">
                                                                <div className="col-md-10 p-0">
                                                                    <div className="admin-control">
                                                                        <UserAvatar width={30} height={30}
                                                                            style={{ borderRadius: u.avatar ? 5 : 0 }}
                                                                            src={u.avatar ? BASE_URL + u.avatar : process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                                                            alt="User avatar"
                                                                            fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                                                                            isKjuup={u.isKjuup || u.companies?.some(c => c.isKjuup)} />
                                                                        <h5>{u.fullName}
                                                                            <span>{u.buldingAdmin ? (strings.admin) : (strings.member)}</span>
                                                                            {
                                                                                (u.department_name && (u.location_name && u.location_name != 'null')) ?
                                                                                    <span>{u.department_name + "/" + u.location_name}</span>
                                                                                    :
                                                                                    <span>{u.department_name}</span>
                                                                            }
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2 pr-0">
                                                                    <div className="custom_checkbox">
                                                                        <label className={company?.isKjuup ? "role-label-internal" : "role-label"}>
                                                                            <input
                                                                                checked={u.buldingAdmin}
                                                                                type="checkbox"
                                                                                value={u.id}
                                                                                onClick={(e) => {}}
                                                                            />
                                                                            <span className={company?.isKjuup ? "checkmark-label-internal" : "checkmark-label"} />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                ))
                                            )
                                        }
                                        </div>
                                    </div>
                                </Card.Body>
                                </div>
                            </Accordion.Collapse>
                            </div>
                        </Card>
                        :
                        <></>
                    }
                    {(totalAdmins > 0 && props.isAdmin && !isDone) && (
                        <Card className="settings-accordion-card">
                            <div className="settings-accordion-panel">
                            <Card.Header
                                className="remove-admin-rights-button settings-accordion-panel-header kj-pointer"
                                onClick={async (e) => {
                                    await $crud.confirm({
                                        title: '',
                                        textContent: strings.remove_my_self_project,
                                        options: {
                                            ok: strings.confirm,
                                            cancel: strings.cancel
                                        }
                                    });
                                    _removeMyself()
                                }}
                            >
                                <span className="settings-row-left project-settings__label">
                                    {strings.remove_my_admin_right}
                                </span>
                                <div className="settings-row-right">
                                    <span className="material-symbols-outlined">close_small</span>
                                </div>
                            </Card.Header>
                            </div>
                        </Card>
                    )}
                    {props.isJoin && !props.viewByOwner && (
                        <Card className="settings-accordion-card">
                            <div className="settings-accordion-panel">
                            <Card.Header className="delete-profile-header settings-accordion-panel-header kj-pointer" onClick={(e) => props.leaveProject(props.project_id)}>
                                <span className="settings-row-left project-settings__label">{strings.leave_project}</span>
                                <div className="settings-row-right">
                                <span className="material-symbols-outlined close_icon pointer">close_small</span>
                                </div>
                            </Card.Header>
                            </div>
                        </Card>
                    )}
                    {props.isAdmin && (
                        <Card className="settings-accordion-card">
                            <div className="settings-accordion-panel">
                            <Card.Header className="email-notification-header settings-accordion-panel-header">
                                <div className="settings-accordion-header-row">
                                <div className="settings-row-left">
                                    <span className="project-settings__label">
                                        {strings.mark_as_completed}
                                    </span>
                                    <InfoTip
                                        className={`project-settings__info-btn${props.isInternal ? ' kj-info-tip--internal' : ''}`}
                                        title={strings.mark_as_completed}
                                        text={strings.info_icon}
                                    />
                                </div>
                                <div className="settings-row-right">
                                <ModernToggleSwitch
                                    id="custom-switch-1"
                                    onChange={(e) => { toggleDone(e.target.checked) }}
                                    checked={isDone}
                                    variant={props.isInternal ? "green" : "orange"}
                                />
                                </div>
                                </div>
                            </Card.Header>
                            </div>
                        </Card>
                    )}
                </Accordion>
            </div>
        </div >

    );
}

export default ProjectSettings;
